import { render, staticRenderFns } from "./purchaseRecords.vue?vue&type=template&id=938aa90e&"
import script from "./purchaseRecords.vue?vue&type=script&lang=js&"
export * from "./purchaseRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('938aa90e')) {
      api.createRecord('938aa90e', component.options)
    } else {
      api.reload('938aa90e', component.options)
    }
    module.hot.accept("./purchaseRecords.vue?vue&type=template&id=938aa90e&", function () {
      api.rerender('938aa90e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/invoiceNo/purchaseRecords.vue"
export default component.exports